import { SVGProps } from 'react'

export const LegalUtopiaGroupIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M24.3418 0H7.65816C3.42868 0 0 3.42867 0 7.65815V24.3418C0 28.5713 3.42868 32 7.65816 32H24.3418C28.5713 32 32 28.5713 32 24.3418V7.65815C32 3.42867 28.5713 0 24.3418 0Z'
      fill='#1C315E'
    />
    <path
      d='M25.9253 4.99609H6.07422V7.67956H25.9253V4.99609Z'
      fill='url(#paint0_linear_25830_21828)'
    />
    <path
      d='M25.9253 24.3184H6.07422V27.0018H25.9253V24.3184Z'
      fill='url(#paint1_linear_25830_21828)'
    />
    <path
      d='M13.4393 20.9285C13.3403 20.7562 13.2524 20.5802 13.1717 20.4006H8.79825V9.46875H6.07812V22.5232H14.6747C14.1945 22.0576 13.7803 21.526 13.4393 20.9248V20.9285Z'
      fill='white'
    />
    <path
      d='M19.9609 22.8677C18.8685 22.8677 17.886 22.6514 17.0062 22.2188C16.1264 21.7862 15.4298 21.13 14.9129 20.2538C14.396 19.374 14.1357 18.2633 14.1357 16.9179V9.55664H16.8559V16.9362C16.8559 18.0983 17.1345 18.9634 17.6954 19.528C18.2563 20.0962 19.0298 20.3785 20.0232 20.3785C21.0167 20.3785 21.7719 20.0962 22.3401 19.528C22.9083 18.9634 23.1906 18.0983 23.1906 16.9362V9.55664H25.9107V16.9179C25.9107 18.2633 25.6431 19.3777 25.1042 20.2538C24.5653 21.1337 23.8468 21.7862 22.9487 22.2188C22.0505 22.6514 21.0534 22.8677 19.9609 22.8677Z'
      fill='white'
    />
    <defs>
      <linearGradient
        id='paint0_linear_25830_21828'
        x1='1.82173'
        y1='6.33783'
        x2='24.3159'
        y2='6.33783'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#3DC3D8' stop-opacity='0' />
        <stop offset='1' stop-color='#3DC3D8' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_25830_21828'
        x1='-113.894'
        y1='25.6601'
        x2='-113.527'
        y2='25.6601'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#3DC3D8' stop-opacity='0' />
        <stop offset='1' stop-color='#3DC3D8' />
      </linearGradient>
    </defs>
  </svg>
)
